module.exports = __webpack_public_path__ + "static/media/Jae Hui Seo_Resume_2023.a692e570.pdf";